import React from 'react';
import T from 'i18n-react';
import { connect } from '../../../../../redux/connect';
import {
  getCurrentViewType,
} from '../../../../../redux/selectors';
import { issueAttributesType } from "../../../../../constants/proptype-validation";
import { SeeMore } from "@adsk/bim360-matrix-react-components";
import PropTypes from "prop-types";
import { toLocalDateTime } from "../../../../../utils/date-helpers";


export function PureIssuePreviewDetailsTabAnswerSection({ issue }) {
  return <form className="IssuePreviewDetailsTabAnswerSection IssuePreviewDetailsTabAnswerSection__wide">
    <div className="IssuePreviewDetailsTabAnswerSection__highlight">
      <div className="IssuePreviewDetailsTabAnswerSection__title">{T.translate('answer.officialResponse')}</div>
      <div className="IssuePreviewDetailsTabAnswerSection__submitter">
        {T.translate('answer.submittedBy', { answerer: issue.answeredByDisplayName, answeredAt: toLocalDateTime(issue.answeredAt) })}
      </div>
      <div className="IssuePreviewDetailsTabAnswerSection__fieldWrapper">
        <SeeMore text={issue.answer} numberOfAllowedLines={3}>{issue.answer} </SeeMore>
      </div>
    </div>
  </form>;
}

PureIssuePreviewDetailsTabAnswerSection.displayName = 'IssuePreviewDetailsTabAnswerSection';

PureIssuePreviewDetailsTabAnswerSection.propTypes = {
  issue: issueAttributesType.isRequired,
  viewType: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  viewType: getCurrentViewType(state),
});

export default connect(mapStateToProps)(PureIssuePreviewDetailsTabAnswerSection);

